module.exports = __webpack_public_path__ + "static/media/loan.cdac7843.png";